import * as actionTypes from "./actionTypes";

export const fetchForms = (forms) => {
    return {
        type: actionTypes.FETCH_FORMS,
        forms,
    };
};

export const fetchForm = (form) => {
    return {
        type: actionTypes.FETCH_FORM,
        form,
    };
};

export const saveDraft = (form) => {
    return {
        type: actionTypes.SAVE_DRAFT,
        form,
    };
};

export const saveForm = (form) => {
    return {
        type: actionTypes.SAVE_FORM,
        form,
    };
};

export const clearForm = () => {
    return {
        type: actionTypes.CLEAR_FORM,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/formBuilder.js